import { createAction } from '@reduxjs/toolkit';
import { RequestWithNetwork } from 'types';

import actionTypes from './actionTypes';

export const getNetwork = createAction<RequestWithNetwork>(actionTypes.GET_NETWORK);
